import Vue from 'vue';
import axios from 'axios';
import store from '@/store'

const baseURL = process.env.VUE_APP_ENGINE_URL;
const tenant = process.env.VUE_APP_TENANT;
const portalTenant = process.env.VUE_APP_PORTAL_TENANT;

const apiUsername = process.env.VUE_APP_ENGINE_API_USER;
const apiPassword = process.env.VUE_APP_ENGINE_API_PASS;
const apiToken = Buffer.from(`${apiUsername}:${apiPassword}`, 'utf8').toString('base64');

const state = {
  usersList: [],
  assignedUsers: [],
  availableUsers: [],
  allUsers: [],
  allUsersSpecial: [],
  deletedUser: '',
  remoteDeletedUser: '',
  addedUser: [],
  remoteAddedUser: [],
  remoteAddedPortal: [],
  updatedUser: [],
  updatedUserCreds: '',
  reassignList: [],
  teamMembers: [],
  userGroups: [],
  userErrorMsg: '',
  addedPortalUser: [],
  allPortalUsers: [],
  remoteUserTenants: [],
  userExists: false
};

const getters = {
  usersList: (state) => state.usersList,
  assignedUsers: (state) => state.assignedUsers,
  availableUsers: (state) => state.availableUsers,
  allUsers: (state) => state.allUsers,
  allUsersSpecial: (state) => state.allUsersSpecial,
  reassignList: (state) => state.reassignList,
  teamMembers: (state) => state.teamMembers,
  userGroups: (state) => state.userGroups,
  userErrorMsg: (state) => state.userErrorMsg,
  allPortalUsers: (state) => state.allPortalUsers,
  remoteAddedUser: (state) => state.remoteAddedUser,
  remoteAddedPortal: (state) => state.remoteAddedPortal,
  remoteDeletedUser: (state) => state.remoteDeletedUser,
  remoteUserTenants: (state) => state.remoteUserTenants
};

const actions = {
  getUserGroups({commit, state}) {
    state.userGroups = [];
    return axios.get(baseURL + '/group?memberOfTenant=' + tenant + '&member=' + store.state.currentUser, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let userGroups = [];

      if(result.data.length > 0) {
        result.data.forEach(item => {
          userGroups.push(item.id);
        });
      }
      store.commit('setUserGroups', userGroups);
      commit('USER_GROUPS', userGroups); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getUsersInGroup({commit}, payload) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant + '&memberOfGroup=' + payload.groupId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      if(result.data.length > 0) {
        if(payload.callType == 'assignedTo') {
          commit('ASSIGNED_USERS', result.data); 
        }else {
          commit('USERS_LIST', result.data); 
        }
      }else {
        commit('USERS_LIST', []);
        commit('ASSIGNED_USERS', []); 
      }     
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getReassignUserList({commit}, payload) {
    let userList = [];
    const PromiseArr = [];
    for(let i = 0; i < payload.groupIds.length; i++) {
      PromiseArr.push(
        axios.get(baseURL + '/user?memberOfTenant=' + tenant + '&memberOfGroup=' + payload.groupIds[i], {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => new Promise(resolve =>
          resolve(result.data)))
      );
    }
    for(let j = 0; j < payload.userIds.length; j++) {
      PromiseArr.push(
        axios.get(baseURL + '/user?memberOfTenant=' + tenant + '&id=' + payload.userIds[j], {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => new Promise(resolve =>
          resolve(result.data)))
      );
    }

    Promise.all(PromiseArr).then(res => {
        
      res.forEach(function(item) {
        item.forEach(function(users) {
          let exists = false;
          userList.forEach(item => {
            if(item.val == users.id) {
              exists = true;
            }
          });
          if(!exists && users.id != payload.assignedTo) {
            userList.push({"name": users.firstName + ' ' + users.lastName, "val": users.id});
          }
        });
      });

      commit('REASSIGN_LIST', userList); 
    });
  },
  userCheck({commit}, username) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( result => {
      let userExists = false;
      
      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          if(username == result.data[i].id) {
            userExists = true;
          }
        }
      }
      
      commit('USER_EXISTS', userExists);
      return userExists;
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllUsers({commit}) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {

      const PromiseArr = [];
      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          Vue.set(result.data[i], 'fullName', result.data[i].firstName + ' ' + result.data[i].lastName);
          PromiseArr.push(
            axios.get(baseURL + '/group?member=' + result.data[i].id + '&type=Role', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
              resolve(resp.data[0])))
          );
        }
      }
      
      Promise.all(PromiseArr).then(res => {
        
        res.forEach(function(item, index) {
          Vue.set(result.data[index], 'role', item.id);
          Vue.set(result.data[index], 'roleName', item.name);
        });

        commit('ALL_USERS', result.data);
      });


    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  // This function is used to marry users and their groups for JS queries within a task
  getAllUsersSpecial({commit}) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {

      const PromiseArr = [];
      if(result.data.length > 0) {
        for(let i = 0; i < result.data.length; i++) {
          PromiseArr.push(
            axios.get(baseURL + '/group?memberOfTenant=' + tenant + '&member=' + result.data[i].id + '&type=Workflow', {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( resp => new Promise(resolve => 
              resolve(resp.data)))
          );
        }
      }

      Promise.all(PromiseArr).then(res => {
        
        res.forEach(function(item, index) {
          let userGroups = [];
          if(item.length > 0) {
            item.forEach(group => {
              userGroups.push({'groupId': group.id, 'groupName': group.name});
            });
          }
          Vue.set(result.data[index], 'groups', userGroups);
        });

        commit('ALL_USERS_SPECIAL', result.data);
      });


    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteUserTenantCheck({commit}, payload) {
    let userTenantInfo = [];
    const PromiseArr = [];

    for(let i = 0; i < payload.tenants.length; i++) {
      PromiseArr.push(
        axios.get(payload.tenants[i].engineUrl + '/engine-rest/user?memberOfTenant=' + payload.tenants[i].tenantId + '&id=' + payload.userId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( resp => new Promise(resolve => 
          resolve(resp.data)))
      );
    }

    Promise.all(PromiseArr).then(res => {
      
      res.forEach(function(item, index) {
        if(item.length > 0) {
          userTenantInfo.push({ 'id': payload.tenants[index].id, 'engineId': payload.tenants[index].engineId, 'tenantId': payload.tenants[index].tenantId, 'tenantName': payload.tenants[index].tenantName });
        }
      });
      commit('REMOTE_USER_TENANTS', userTenantInfo);
    });
  },
  remoteUserCheck({commit, state}, payload) {
    state.userExists = false;
    return axios.get(payload.enginePayload.engineUrl + '/engine-rest/user?id=' + payload.userPayload.profile.id, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 200) {
        if(res.data.length > 0) {
          commit('USER_EXISTS', true);
        }else {
          commit('USER_EXISTS', false);
        }
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  deleteUser({commit}, userId) {
    return axios.delete(baseURL + '/user/' + userId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
      commit('DELETED_USER', userId); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteDeleteUser({commit}, payload) {
    return axios.delete(payload.enginePayload.engineUrl + '/engine-rest/user/' + payload.userId, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        commit('REMOTE_DELETED_USER', payload.userId);
      }else {
        commit('REMOTE_DELETED_USER', '');
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  addUser({commit}, payload) {
    return axios.post(baseURL + '/user/create', payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        return axios.put(baseURL + '/tenant/' + tenant + '/user-members/' + payload.profile.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
          commit('ADDED_USER', payload); 
        }).catch(error => {
          let msg = 'User creation failed. ' + error;
          commit('USER_ERROR_MESSAGE', msg);
        });
      }
    }).catch(error => {
        let msg = 'User creation failed. Please make sure the password complies with the stated policy. ' + error;
        commit('USER_ERROR_MESSAGE', msg);
    });
  },
  async remoteAddUser({commit, state}, payload) {
    let enginePayload = {};
    let engineName = '';
    let tenantName = '';

    for(let i = 0; i < payload.tenantSelected.length; i++) {
      let selectedId = payload.tenantSelected[i];

      for(let j = 0; j < payload.tenantInfo.length; j++) {
        if(selectedId == payload.tenantInfo[j].id) {
          let engineId = payload.tenantInfo[j].engineId;
          let tenantId = payload.tenantInfo[j].tenantId;
          tenantName = payload.tenantInfo[j].tenantName;

          for(let k = 0; k < payload.allHqConns.length; k++) {
            if(engineId == payload.allHqConns[k].ID) {
              let engineUrl = payload.allHqConns[k].URL;
              engineName = payload.allHqConns[k].ENGINE_NAME;

              enginePayload = { 
                'tenantId': tenantId, 
                'engineUrl': engineUrl
              };

              break;
            }
          }
        }
      }

      let remoteCheckPayload = {
        'userPayload': payload.userPayload,
        'enginePayload': enginePayload,
        'engineName': engineName
      };

      let remoteRolePayload = {
        'rolePayload': payload.rolePayload,
        'enginePayload': enginePayload,
        'engineName': engineName,
        'tenantName': tenantName
      };
      
      await this.dispatch('remoteUserCheck', remoteCheckPayload).then( () => {
        if(!state.userExists) {
          return axios.post(enginePayload.engineUrl + '/engine-rest/user/create', payload.userPayload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
            if(res.status == 204) {
              return axios.put(enginePayload.engineUrl + '/engine-rest/tenant/' + enginePayload.tenantId + '/user-members/' + payload.userPayload.profile.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res2 => {
                if(res2.status == 204) {
                  this.dispatch('remoteAddUserToRole', remoteRolePayload);

                  //If admin, give access to portal
                  if(payload.rolePayload.id == 'adminRole') {
                    this.dispatch('remoteAddUserToPortal', remoteCheckPayload);
                  }

                  let data = {
                    'msg': 'User ' + payload.userPayload.profile.id + ' successfully created on ' + engineName + '.',
                    'log': 'User ' + payload.userPayload.profile.id + ' created remotely on engine ' + engineName + ', tenant ' + tenantName + '.',
                    'success': true
                  }
                  commit('REMOTE_ADDED_USER', data); 
                }else {
                  let data = {
                    'msg': 'User ' + payload.userPayload.profile.id + ' could not be created on ' + engineName + '.',
                    'success': false
                  }
                  commit('REMOTE_ADDED_USER', data); 
                }
              }).catch(error => {
                let msg = 'Remote user creation failed. ' + error;
                commit('USER_ERROR_MESSAGE', msg);
              });
            }
          }).catch(error => {
              let msg = 'Remote user creation failed. ' + error;
              commit('USER_ERROR_MESSAGE', msg);
          });
        }else {
          let msg = 'This user already exists on the target engine (' + engineName + ').';
          commit('USER_ERROR_MESSAGE', msg);
        }
      });
    }
  },
  remoteAddUserToPortal({commit}, payload) {
    return axios.put(payload.enginePayload.engineUrl + '/engine-rest/tenant/portal/user-members/' + payload.userPayload.profile.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        let data = {
          'msg': 'User ' + payload.userPayload.profile.id + ' successfully added to Portal on ' + payload.engineName + '.',
          'success': true
        }
        commit('REMOTE_ADDED_PORTAL', data); 
      }else {
        let data = {
          'msg': 'User ' + payload.userPayload.profile.id + ' could not be added to Portal on ' + payload.engineName + '.',
          'success': false
        }
        commit('REMOTE_ADDED_PORTAL', data); 
      }
    }).catch(error => {
      let msg = 'Failed to add remote user to tenant. ' + error;
      commit('USER_ERROR_MESSAGE', msg);
    });
  },
  editUser({commit}, payload) {
    return axios.put(baseURL + '/user/' + payload.id + '/profile', payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        commit('UPDATED_USER', payload); 
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  updateUserCreds({commit}, payload) {
    return axios.put(baseURL + '/user/' + payload.userId + '/credentials', payload.credData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        commit('UPDATED_USER_CREDS', payload.userId); 
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteEditUser({commit}, payload) {
    return axios.put(payload.engineUrl + '/engine-rest/user/' + payload.userPayload.id + '/profile', payload.userPayload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        commit('UPDATED_USER', payload.userPayload); 
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  remoteUpdateUserCreds({commit}, payload) {
    return axios.put(payload.engineUrl + '/engine-rest/user/' + payload.userId + '/credentials', payload.credData, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + apiToken}}).then( res => {
      if(res.status == 204) {
        commit('UPDATED_USER_CREDS', payload.userId); 
      }
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getUnassignedUsers({commit}) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      let assignedUsers = this.getters.assignedUsers;
      let availableUsers = [];
      let found = false;

      for(let i = 0; i < result.data.length; i++) {
        for(let j = 0; j < assignedUsers.length; j++) {
          if(assignedUsers[j].id == result.data[i].id) {
            found = true;
          }
        }
        if(!found) {
          availableUsers.push(result.data[i]);
        }
        found = false;
      }

      commit('AVAILABLE_USERS', availableUsers); 
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getTeamMembers({commit}) {
    return axios.get(baseURL + '/user?memberOfTenant=' + tenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {
      commit('TEAM_MEMBERS', result.data);
    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  getAllPortalUsers({commit}) {
    return axios.get(baseURL + '/user?memberOfTenant=' + portalTenant, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( result => {

      commit('ALL_PORTAL_USERS', result.data);

    }).catch(error => {
      throw new Error(`API ${error}`);
    });
  },
  createPortalUser({commit}, payload) {
    return axios.post(baseURL + '/user/create', payload, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( res => {
      if(res.status == 204) {
        return axios.put(baseURL + '/tenant/' + payload.targetPortal + '/user-members/' + payload.profile.id, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
          commit('ADDED_PORTAL_USER', payload); 
        }).catch(error => {
          let msg = 'User creation failed. ' + error;
          commit('USER_ERROR_MESSAGE', msg);
        });
      }
    }).catch(error => {
        let msg = 'User creation failed. Please make sure the password complies with the stated policy. ' + error;
        commit('USER_ERROR_MESSAGE', msg);
    });
  },
  addUserToPortal({commit}, userId) {
    if(portalTenant != '') {
      return axios.put(baseURL + '/tenant/' + portalTenant + '/user-members/' + userId, {}, {headers: {'Content-Type': 'application/json', 'Authorization': 'Basic ' + store.state.token}}).then( () => {
        commit('ADDED_USER', userId); 
      }).catch(error => {
        let msg = 'Unable to add user to portal tenant. ' + error;
        commit('USER_ERROR_MESSAGE', msg);
      });
    }
  }
};

const mutations = {
  USERS_LIST(state, payload) {
    state.usersList = payload;
  },
  ASSIGNED_USERS(state, payload) {
    state.assignedUsers = payload;
  },
  AVAILABLE_USERS(state, payload) {
    state.availableUsers = payload;
  },
  ALL_USERS(state, payload) {
    state.allUsers = payload;
  },
  ALL_USERS_SPECIAL(state, payload) {
    state.allUsersSpecial = payload;
  },
  DELETED_USER(state, payload) {
    state.deletedUser = payload;
  },
  REMOTE_DELETED_USER(state, payload) {
    state.remoteDeletedUser = payload;
  },
  ADDED_USER(state, payload) {
    state.addedUser = payload;
  },
  REMOTE_ADDED_USER(state, payload) {
    state.remoteAddedUser = payload;
  },
  REMOTE_ADDED_PORTAL(state, payload) {
    state.remoteAddedPortal = payload;
  },
  UPDATED_USER(state, payload) {
    state.updatedUser = payload;
  },
  UPDATED_USER_CREDS(state, payload) {
    state.updatedUserCreds = payload;
  },
  REASSIGN_LIST(state, payload) {
    state.reassignList = payload;
  },
  TEAM_MEMBERS(state, payload) {
    state.teamMembers = payload;
  },
  USER_GROUPS(state, payload) {
    state.userGroups = payload;
  },
  USER_ERROR_MESSAGE(state, payload) {
    state.userErrorMsg = payload;
  },
  ADDED_PORTAL_USER(state, payload) {
    state.addedPortalUser = payload;
  },
  ALL_PORTAL_USERS(state, payload) {
    state.allPortalUsers = payload;
  },
  REMOTE_USER_TENANTS(state, payload) {
    state.remoteUserTenants = payload;
  },
  USER_EXISTS(state, payload) {
    state.userExists = payload;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}